/*
 * @Desc: 路由入口
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: 赵佳明
 * @LastEditTime: 2023-02-03 08:44:48
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved.
 */
import Vue from 'vue';
import Router from 'vue-router';
// import store from '.././vuex/store'
import routers from './routers';
import { getIsMobile, isPC } from '@/utils/device';

Vue.use(Router);

const router = new Router({
  mode: 'history', // 'hash', // 'history',
  routes: routers,
});

/**
 * role 0 为普通用户，目前没有其他角色；
 * keepAlive 为是否缓存页面，默认为false 不缓存
 */

// 导航钩子，全局钩子
router.beforeEach((to, from, next) => {
  const isMobile = getIsMobile();
  if (to.meta.title) {
    window.document.title = to.meta.title;
  }
  if (isMobile && !to.path.includes('phone')) {
    next({ name: `phone-${to.name}` });
  }
  if (!isMobile && to.path.includes('phone')) {
    next({ name: to.name.replace('phone-', '') });
  }
  next();
});

router.afterEach(() => {
  // 滚动到页面顶部
  window.scrollTo({
    top: 0,
    behavior: 'smooth', // 使用平滑滚动效果
  });
});

export default router;
